<template>
  <v-row class="chart">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" lg="7" md="6">
          <v-tabs show-arrows v-model="tabs" background-color="transparent">
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab>{{ $t("charts.hour") }}</v-tab>
            <v-tab>{{ $t("charts.day") }}</v-tab>
            <v-tab>{{ $t("charts.week") }}</v-tab>
            <v-tab>{{ $t("charts.month") }}</v-tab>
            <v-tab>{{ $t("charts.year") }}</v-tab>
          </v-tabs>
        </v-col>

        <v-col cols="12" lg="5" md="4">
          <v-row>
            <v-btn v-on:click="btnClickEventPrevious()" :readonly="this.tabs < 1 || this.actualDateTime === this.chosenDateTime" fab text small dark :color="colorArrow">
              <v-icon dark>mdi-skip-previous</v-icon>
            </v-btn>
            <v-btn text readonly large>{{ picker }}</v-btn>
            <v-btn v-on:click="btnClickEventNext()" :readonly="this.tabs < 1" fab text small dark :color="colorArrow">
              <v-icon dark>mdi-skip-next</v-icon>
            </v-btn>

            <v-spacer></v-spacer>

            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn large icon dark color="primary" v-on="on">
                  <v-icon>mdi-calendar-today</v-icon>
                </v-btn>
              </template>

              <v-date-picker @change="onChangeDatePickerEvent()" v-model="picker" :locale="`${$i18n.locale}`" :readonly="this.tabs < 1"></v-date-picker>
            </v-menu>

            <v-spacer></v-spacer>

            <v-btn large icon @click="btnClickChartLine" :color="colorChartTypeLine" dark>
              <v-icon>mdi-chart-areaspline-variant</v-icon>
            </v-btn>
            <v-btn large icon @click="btnClickChartBar" :color="colorChartTypeBar" dark>
              <v-icon>mdi-chart-bar</v-icon>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <div class="white">
        <v-tabs-items>
          <!--           <div class="small"> -->
          <AnyChart2 :heightSheet="600" :heightChart="550" :dark="$vuetify.theme.dark" :tabs="tabs" :start="this.start" :stop="this.stop" :ct="this.chartType" :card="false" />
          <!--           </div> -->
        </v-tabs-items>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import AnyChart2 from "../../components/charts/AnyChart2.vue";

export default {
  name: "ESCBCharts",
  components: {
    AnyChart2,
  },
  data() {
    return {
      timer: null,
      colorArrow: "grey",
      colorChartTypeLine: "primary",
      colorChartTypeBar: "grey",
      picker: new Date().toISOString().substr(0, 10),
      actualDateTime: new Date(),
      chosenDateTime: new Date(),

      start: "",
      stop: "",
      chartType: "Line",
      tabs: 0,
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.tellMeTime();
    }, 1000);
  },
  methods: {
    tellMeTime: function () {
      this.actualDateTime = new Date();

      if (this.start === "" && this.stop === "") {
        this.chosenDateTime = new Date();
      }
    },
    updatePickerWithActualDateTime: function () {
      this.picker = this.actualDateTime.toISOString().substr(0, 10);
    },
    clearStartStop: function () {
      this.start = "";
      this.stop = "";
    },
    calculateInterval: function () {
      var dateTime = new Date();

      var sStart = this.picker.substr(0, 4) + this.picker.substr(5, 2) + this.picker.substr(8, 2);

      var sStop = "";

      dateTime.setYear(this.picker.substr(0, 4));
      dateTime.setMonth(this.picker.substr(5, 2) - 1);
      dateTime.setDate(this.picker.substr(8, 2));

      switch (this.tabs) {
        case 0:
          this.clearStartStop();
          break;

        case 1:
          dateTime.setDate(this.chosenDateTime.getDate());
          dateTime = dateTime.toISOString().substr(0, 10);

          sStop = dateTime.substr(0, 4) + dateTime.substr(5, 2) + dateTime.substr(8, 2);

          this.start = sStart + "0000";
          this.stop = sStop + "2359";
          break;

        case 2:
          dateTime.setDate(this.chosenDateTime.getDate() + 6);
          dateTime = dateTime.toISOString().substr(0, 10);

          sStop = dateTime.substr(0, 4) + dateTime.substr(5, 2) + dateTime.substr(8, 2);

          this.start = sStart + "0000";
          this.stop = sStop + "2359";
          break;

        case 3:
          dateTime.setMonth(this.chosenDateTime.getMonth() + 1);
          dateTime = dateTime.toISOString().substr(0, 10);

          sStop = dateTime.substr(0, 4) + dateTime.substr(5, 2) + dateTime.substr(8, 2);

          this.start = sStart + "0000";
          this.stop = sStop + "2359";
          break;

        case 4:
          dateTime.setFullYear(this.chosenDateTime.getFullYear() + 1);
          dateTime = dateTime.toISOString().substr(0, 10);

          sStop = dateTime.substr(0, 4) + dateTime.substr(5, 2) + dateTime.substr(8, 2);

          this.start = sStart + "0000";
          this.stop = sStop + "2359";
          break;

        default:
          this.clearStartStop();
      }
    },
    btnClickChartBar: function () {
      this.colorChartTypeBar = "primary";
      this.colorChartTypeLine = "grey";

      this.chartType = "Bar";
    },
    btnClickChartLine: function () {
      this.colorChartTypeLine = "primary";
      this.colorChartTypeBar = "grey";

      this.chartType = "Line";
    },
    btnClickEventPrevious: function () {
      this.calculateDateTimeOffset("Previous");
    },
    btnClickEventNext: function () {
      this.calculateDateTimeOffset("Next");
    },
    onChangeDatePickerEvent: function () {
      var dtActual = new Date();
      var dtChosen = new Date();

      dtChosen.setYear(this.picker.substr(0, 4));
      dtChosen.setMonth(this.picker.substr(5, 2) - 1);
      dtChosen.setDate(this.picker.substr(8, 2));

      if (dtChosen.getFullYear() > dtActual.getFullYear() || (dtChosen.getFullYear() === dtActual.getFullYear() && dtChosen.getMonth() > dtActual.getMonth()) || (dtChosen.getMonth() === dtActual.getMonth() && dtChosen.getDate() >= dtActual.getDate())) {
        this.picker = dtActual.toISOString().substr(0, 10);
        this.chosenDateTime = dtActual;
        this.clearStartStop();
        return;
      } else {
        this.chosenDateTime = dtChosen;
        this.calculateInterval();
      }
    },
    calculateDateTimeOffset: function (string) {
      var value = 0;

      if (string === "Previous") {
        value = -1;
      } else if (string === "Next") {
        value = 1;
      }

      switch (this.tabs) {
        case 0:
          this.chosenDateTime.setHours(this.chosenDateTime.getHours() + 2 * value);
          break;
        case 1:
          this.chosenDateTime.setDate(this.chosenDateTime.getDate() + value);
          break;
        case 2:
          this.chosenDateTime.setDate(this.chosenDateTime.getDate() + 6 * value);
          break;
        case 3:
          this.chosenDateTime.setMonth(this.chosenDateTime.getMonth() + value);
          break;
        case 4:
          this.chosenDateTime.setFullYear(this.chosenDateTime.getFullYear() + value);
          break;

        default:
      }

      if (this.chosenDateTime.getFullYear() === this.actualDateTime.getFullYear() && this.chosenDateTime.getMonth() === this.actualDateTime.getMonth() && this.chosenDateTime.getDate() === this.actualDateTime.getDate()) {
        this.updatePickerWithActualDateTime();
        this.clearStartStop();
        return;
      }

      if (
        this.chosenDateTime.getFullYear() > this.actualDateTime.getFullYear() ||
        (this.chosenDateTime.getFullYear() === this.actualDateTime.getFullYear() && this.chosenDateTime.getMonth() > this.actualDateTime.getMonth()) ||
        (this.chosenDateTime.getMonth() === this.actualDateTime.getMonth() && this.chosenDateTime.getDate() > this.actualDateTime.getDate()) ||
        this.chosenDateTime.getHours() > this.actualDateTime.getHours()
      ) {
        this.chosenDateTime = this.actualDateTime;
        this.clearStartStop();
        this.updatePickerWithActualDateTime();
        return;
      }

      this.picker = this.chosenDateTime.toISOString().substr(0, 10);

      this.calculateInterval();
    },
  },
  watch: {
    tabs: function () {
      if (this.tabs === 0) {
        this.colorArrow = "grey";
        this.btnClickChartLine();
      } else {
        this.colorArrow = "primary";
        this.btnClickChartBar();
      }
      this.clearStartStop();
    },
  },
  beforeDestroy: function () {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
.small {
  margin: auto;
}
</style>
